function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { Container } from '../../../../../../components/CountrySwitch/components/CountrySwitchDesktop/components/Label/Container.js';
import { MaskedLink } from '../../../../../../components/internal/MaskedLink/index.js';
import { NextImage } from '../../../../../../components/internal/NextImage/index.js';
import { LabelMedium, Stack } from '../../../../../../primitives/index.js';
import { useDirectusImageUrl } from '../../../../../../utils/directus.js';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "g65o95",
  styles: "text-decoration:none"
} : {
  name: "qrf7sp-css",
  styles: "text-decoration:none;label:css;/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVEyRCIsImZpbGUiOiJpbmRleC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGpzeCBhcyBfanN4LCBqc3hzIGFzIF9qc3hzIH0gZnJvbSBcIkBlbW90aW9uL3JlYWN0L2pzeC1ydW50aW1lXCI7XG5pbXBvcnQgeyBjc3MgfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyBDb250YWluZXIgfSBmcm9tICcuLi8uLi8uLi8uLi8uLi8uLi9jb21wb25lbnRzL0NvdW50cnlTd2l0Y2gvY29tcG9uZW50cy9Db3VudHJ5U3dpdGNoRGVza3RvcC9jb21wb25lbnRzL0xhYmVsL0NvbnRhaW5lci5qcyc7XG5pbXBvcnQgeyBNYXNrZWRMaW5rIH0gZnJvbSAnLi4vLi4vLi4vLi4vLi4vLi4vY29tcG9uZW50cy9pbnRlcm5hbC9NYXNrZWRMaW5rL2luZGV4LmpzJztcbmltcG9ydCB7IE5leHRJbWFnZSB9IGZyb20gJy4uLy4uLy4uLy4uLy4uLy4uL2NvbXBvbmVudHMvaW50ZXJuYWwvTmV4dEltYWdlL2luZGV4LmpzJztcbmltcG9ydCB7IExhYmVsTWVkaXVtLCBTdGFjayB9IGZyb20gJy4uLy4uLy4uLy4uLy4uLy4uL3ByaW1pdGl2ZXMvaW5kZXguanMnO1xuaW1wb3J0IHsgdXNlRGlyZWN0dXNJbWFnZVVybCB9IGZyb20gJy4uLy4uLy4uLy4uLy4uLy4uL3V0aWxzL2RpcmVjdHVzLmpzJztcbmV4cG9ydCBjb25zdCBMYWJlbCA9ICh7IGRhdGEgfSkgPT4ge1xuICAgIHJldHVybiAoX2pzeChNYXNrZWRMaW5rLCB7IGhyZWY6IGRhdGEuZG9tYWluLCBjc3M6IGNzcyBgXG4gICAgICAgIHRleHQtZGVjb3JhdGlvbjogbm9uZTtcbiAgICAgIGAsIGNoaWxkcmVuOiBfanN4cyhTdGFjaywgeyBkaXJlY3Rpb246IFwicm93XCIsIGFsaWduSXRlbXM6IFwiY2VudGVyXCIsIGNoaWxkcmVuOiBbX2pzeChOZXh0SW1hZ2UsIHsgd2lkdGg6IDIxLCBoZWlnaHQ6IDE1LCBpbWFnZTogdXNlRGlyZWN0dXNJbWFnZVVybChkYXRhLmljb24/LnVybCksIGFsdDogXCJcIiB9KSwgX2pzeChDb250YWluZXIsIHsgY2hpbGRyZW46IF9qc3goTGFiZWxNZWRpdW0sIHsgY2hpbGRyZW46IGRhdGEubmFtZSB9KSB9KV0gfSkgfSkpO1xufTtcbi8vIyBzb3VyY2VNYXBwaW5nVVJMPWluZGV4LmpzLm1hcCJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export const Label = ({
  data
}) => {
  return _jsx(MaskedLink, {
    href: data.domain,
    css: _ref,
    children: _jsxs(Stack, {
      direction: "row",
      alignItems: "center",
      children: [_jsx(NextImage, {
        width: 21,
        height: 15,
        image: useDirectusImageUrl(data.icon?.url),
        alt: ""
      }), _jsx(Container, {
        children: _jsx(LabelMedium, {
          children: data.name
        })
      })]
    })
  });
};